import { render } from "./filterTruck.vue?vue&type=template&id=6b7c0466"
import script from "./filterTruck.vue?vue&type=script&lang=js"
export * from "./filterTruck.vue?vue&type=script&lang=js"

import "./filterTruck.vue?vue&type=style&index=0&id=6b7c0466&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__